import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '12.1449 2.5435'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M0.419922 0.739746C4.28992 2.04975 8.20991 2.83973 12.1599 2.84973C14.1299 2.88973 16.0999 2.71971 18.0499 2.32971C20.0199 2.00971 21.8999 1.34975 23.8699 0.739746C22.1999 1.90975 20.3399 2.91973 18.3299 3.46973C17.3399 3.82973 16.2999 3.94973 15.2799 4.15973C14.2399 4.24973 13.1999 4.37972 12.1499 4.33972C10.0599 4.30972 7.96991 4.01972 5.98991 3.39972C3.99991 2.80972 2.07992 1.94975 0.419922 0.739746Z"
          fill={outline}
        />
      </g>
    </g>
  )
}
